<div mat-dialog-title>
  <span>{{isEdit ? 'Edit user' : 'Create new user'}}</span>
</div>
<div mat-dialog-content>
  <form #f="ngForm" class="d-flex flex-column mt-1"> <!--toni I added mt- class because it was being choped off on top-->
    <mat-form-field floatLabel="always" color="primary" appearance="outline">
      <mat-label>Email</mat-label>
      <input [disabled]="isEdit" name="username" email matInput required [(ngModel)]="user.email"/>
    </mat-form-field>
    <mat-form-field floatLabel="always" color="primary" appearance="outline">
      <mat-label>Name</mat-label>
      <input name="name" matInput required [(ngModel)]="user.name"/>
    </mat-form-field>
    <mat-form-field floatLabel="always" color="primary" appearance="outline" *ngIf="!isEdit">
      <mat-label>Password</mat-label>
      <input name="password" matInput required [(ngModel)]="user.password"/>
    </mat-form-field>
    <mat-form-field floatLabel="always" color="primary" appearance="outline">
      <mat-label>Roles</mat-label>
      <mat-select name="roles" [multiple]="true" [(ngModel)]="user.roles" [disabled]="disabled" required>
        <mat-option *ngFor="let dp of userRoleKL" [value]="dp.key">{{dp.label}}</mat-option>
      </mat-select>
    </mat-form-field>
    <div class="" *ngIf="isPublisher()">
      <ctv-publisher-autocomplete-chips [publisherIds]="user.publisherIds"
                                        (publisherSelectionChange)="onPublisherSelection($event)"
                                        [networkIds]="[networkId]"
                                        [networkIdsChanged]="eventsSubjectNetwork.asObservable()"
                                        [clearItems]="clearFilterItems.asObservable()"
                                        [required]="isPublisher()"
                                        formFieldAppearance="outline">
      </ctv-publisher-autocomplete-chips>
    </div>
    <div class="" *ngIf="(user.roles && user.roles.includes(userRole.CONTENT_OWNER) && !userType) || (userType && user.contentOwners)">
      <ctv-content-owner-autocomplete-chips [contentOwners]="user.contentOwners"
                                            (contentOwnerSelectionChange)="onContentOwnerSelection($event)"
                                            [disabled]="disabled"
                                            formFieldAppearance="outline"></ctv-content-owner-autocomplete-chips>
    </div>
  </form>
</div>
<div mat-dialog-actions>
  <button mat-stroked-button class="mr-2" [mat-dialog-close]="false">
    Close
  </button>
  <button mat-flat-button *csHasPermission="RolePermission.USERS_CREATE" class="iconed" color="primary"
          [disabled]="!f.valid || (user && user.roles && user.roles.includes(userRole.PUBLISHER)
                && (!user.publisherIds || !user.publisherIds.length) || moreThanOneMainRoleSelected())"
          (click)="createUser()">
    <i class="fas fa-save"></i>
    <span>Save</span>
  </button>
</div>
